import request from "@/router/axios";

export const getRealtimeRtkStaffPage = (data) => {
    return request({
        url: "/api/produce/employee-device-rel/realtime/page",
        method: "post",
        data,
    });
};
